import React from "react";
import "./me.css";
import myPicture from "./me.jpg";

const Me = () => {
  return (
    <div className="root-container mt-4">
      <div className="container border about-me rounded">
        <div className="overflow-auto mx-auto my-4 text-center">
          <h2>This a brief about me</h2>
          <div className="picture-container text-center pt-2">
            <img className="rounded my-img" src={myPicture} alt="Michael" />
          </div>
          <div className="pt-2">
            <div className="paragraph-container-left">
              <p className="fw-light">
                Hello, My Name is Michael, 5+ years of experience working with
                varied industry groups to deliver high-impact digital solutions
                as a creative front-end developer. Capable of planning,
                creating, and testing a variety of web-based apps that use a
                variety of technologies. Aiming to flourish as a front-end
                developer by fusing a broad educational background with solid
                technical abilities.
              </p>
              <p className="fw-light">
                I believe I am in a constant learning curve and any opportunity
                to work as a developer is a chance for me to become a better
                FrontEnd developer and that is what I'm always looking forward
                to every challenge.
              </p>
              <p className="fw-light">
                I desire to deliver quality products that ticks all the boxes of
                the client needs and which further will be a problem solver in
                the digital world space. Quality work will guarantee more
                clients and that is an aspect I believe in and acts as the
                driving force in quality work delivery.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Me;
